module.exports = __webpack_public_path__ + "static/media/profileIcon.363abbf8.png";